(() => {
  const DESKTOP_MQ = window.matchMedia("(min-width: 768px)");

  function getMainQty() {
    return document.getElementById("required-metres-squared");
  }

  function getMainWastage() {
    return document.getElementById("wastage-fee");
  }

  function getMainAtcButton() {
    return (
      document.querySelector(".cart-essentials-open-btn") ||
      document.querySelector(
        'product-form.product-form .product-form__buttons button[type="submit"].button--submit'
      )
    );
  }

  function getPriceSource(sectionId) {
    return document.querySelector(`#price-${sectionId} .product__details-prices`);
  }

  function init() {
    const sticky = document.getElementById("SfStickyAtc");
    if (!sticky) return;

    const sectionId = sticky.dataset.sectionId;
    const stickyQty = document.getElementById("sf-sticky-required-metres-squared");
    const stickyWastage = document.getElementById("sf-sticky-wastage-fee");
    const stickyBtn = document.getElementById("SfStickyAtcButton");
    const sentinel =
      document.querySelector("product-quantity-input") ||
      document.querySelector(".product-form__buttons") ||
      document.querySelector("product-form.product-form");

    if (!sentinel || !stickyQty || !stickyBtn) return;

    const stickyPrice = sticky.querySelector("[data-sticky-price] .product__details-prices");
    let syncing = false;

    const setVisible = (visible) => {
      sticky.classList.toggle("is-visible", visible);
      sticky.toggleAttribute("hidden", !visible);
      sticky.setAttribute("aria-hidden", visible ? "false" : "true");
      document.body.classList.toggle("sf-sticky-atc-visible", visible);

      if (visible) {
        document.documentElement.style.setProperty(
          "--sf-sticky-atc-height",
          `${sticky.offsetHeight || 0}px`
        );
      } else {
        document.documentElement.style.removeProperty("--sf-sticky-atc-height");
      }
    };

    const syncPrices = () => {
      const priceSource = getPriceSource(sectionId);
      if (!priceSource || !stickyPrice) return;
      stickyPrice.innerHTML = priceSource.innerHTML;
    };

    const syncDisabled = () => {
      const mainAtcButton = getMainAtcButton();
      if (!mainAtcButton) return;
      stickyBtn.disabled = mainAtcButton.disabled;
    };

    const syncLoadingState = () => {
      const mainAtcButton = getMainAtcButton();
      if (!mainAtcButton) return;

      const isLoading = mainAtcButton.classList.contains("loading");
      stickyBtn.classList.toggle("loading", isLoading);

      if (mainAtcButton.hasAttribute("aria-disabled")) {
        stickyBtn.setAttribute("aria-disabled", mainAtcButton.getAttribute("aria-disabled"));
      } else {
        stickyBtn.removeAttribute("aria-disabled");
      }

      const mainOverlay = mainAtcButton.querySelector(".loading-overlay__spinner");
      const stickyOverlay = stickyBtn.querySelector(".loading-overlay__spinner");
      if (mainOverlay && stickyOverlay) {
        stickyOverlay.classList.toggle("hidden", mainOverlay.classList.contains("hidden"));
      } else if (stickyOverlay) {
        stickyOverlay.classList.toggle("hidden", !isLoading);
      }
    };

    const observeMainAtcDisabled = () => {
      const mainAtcButton = getMainAtcButton();
      if (!mainAtcButton) return;

      // Initial sync
      syncDisabled();
      syncLoadingState();

      const observer = new MutationObserver(() => {
        syncDisabled();
        syncLoadingState();
      });
      observer.observe(mainAtcButton, {
        attributes: true,
        attributeFilter: ["disabled", "class", "aria-disabled"],
      });
    };

    const dispatchInput = (input, value) => {
      if (!input) return;
      input.value = value;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    const syncFromMain = () => {
      if (syncing) return;
      syncing = true;
      const mainQty = getMainQty();
      const mainWastage = getMainWastage();
      if (mainQty && stickyQty) stickyQty.value = mainQty.value;
      if (mainWastage && stickyWastage) stickyWastage.checked = mainWastage.checked;
      syncDisabled();
      syncing = false;
    };

    const syncToMain = () => {
      if (syncing) return;
      syncing = true;
      const mainQty = getMainQty();
      const mainWastage = getMainWastage();
      if (mainQty && stickyQty) dispatchInput(mainQty, stickyQty.value);
      if (mainWastage && stickyWastage) {
        mainWastage.checked = stickyWastage.checked;
        mainWastage.dispatchEvent(new Event("change", { bubbles: true }));
      }
      syncDisabled();
      syncing = false;
    };

    document.addEventListener("input", (event) => {
      if (event.target.id === "required-metres-squared") {
        syncFromMain();
        // Main PDP quantity logic can update disabled state asynchronously.
        // A next-tick re-sync removes perceived lag when typing.
        window.setTimeout(syncFromMain, 0);
      }
    });

    document.addEventListener("change", (event) => {
      if (event.target.id === "required-metres-squared" || event.target.id === "wastage-fee") {
        syncFromMain();
      }
    });

    stickyQty.addEventListener("input", syncToMain);
    stickyQty.addEventListener("change", syncToMain);
    if (stickyWastage) {
      stickyWastage.addEventListener("change", syncToMain);
    }

    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (priceRoot && stickyPrice) {
      syncPrices();
      const priceObserver = new MutationObserver(() => {
        syncPrices();
        syncFromMain();
        syncDisabled();
      });
      priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    const getSentinel = () =>
      document.querySelector("product-quantity-input") ||
      document.querySelector(".product-form__buttons") ||
      document.querySelector("product-form.product-form");

    let observedSentinel = sentinel;
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(show);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: DESKTOP_MQ.matches ? "-80px 0px 0px 0px" : "0px",
      }
    );
    io.observe(observedSentinel);

    const productTemplate = document.getElementById(`productTemplate-${sectionId}`);
    if (productTemplate) {
      const templateObserver = new MutationObserver(() => {
        const nextSentinel = getSentinel();
        if (!nextSentinel || nextSentinel === observedSentinel) return;
        io.unobserve(observedSentinel);
        observedSentinel = nextSentinel;
        io.observe(observedSentinel);
        syncFromMain();
        syncPrices();
        syncDisabled();
      });
      templateObserver.observe(productTemplate, { childList: true, subtree: true });
    }

    window.addEventListener(
      "resize",
      () => {
        if (sticky.classList.contains("is-visible")) {
          document.documentElement.style.setProperty(
            "--sf-sticky-atc-height",
            `${sticky.offsetHeight || 0}px`
          );
        }
      },
      { passive: true }
    );

    stickyBtn.addEventListener("click", () => {
      syncToMain();
      const mainAtcButton = getMainAtcButton();
      if (!mainAtcButton || mainAtcButton.disabled) return;
      mainAtcButton.click();
    });

    observeMainAtcDisabled();
    syncFromMain();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
